import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {HttpModule} from '@angular/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {AngularFontAwesomeModule} from 'angular-font-awesome';
//Components
import {AppComponent} from './app.component';
import {HeaderComponent} from './header/header.component';
import {LoginComponent} from './login/login.component';
import {ForgotPasswordComponent} from './forgot-password/forgot-password.component';
import {VerificationComponent} from './verification/verification.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {ActivationComponent} from './activation/activation.component';
import {MainComponent} from './main/main.component';
import {UserEditModalComponent} from './modal-edit/modal-edit.component';
import {PasswordStrengthBarModule} from 'ng2-password-strength-bar';
import {SupportComponent} from './support/support.component';
import {AnalyticsComponent} from './main/analytics/analytics.component';
//Guard
import {AuthGuard} from './authguard.guard';
import {AuthCodeGuard} from './authcodeguard.guard';
//Service
import {UserService} from './service/user.service';
import {OrganizationService} from './service/organization.service';
import {DropdownDirective} from './shared/dropdown.directive';
import {CreateUserComponent} from './modal-edit/create-user/create-user.component';
// Pipes
import {ActiveStatusPipe} from './shared/pipes/activeStatus.pipe';
import {CreateApiKeyComponent} from './modal-edit/create-api-key/create-api-key.component';
import {SearchFilterPipe} from './shared/pipes/searchFilter.pipe';
import {StoreFilterCountPipe} from './shared/pipes/storeFilterCount.pipe';
import {OrganisationFormComponent} from './modal-edit/organisation-form/organisation-form.component';
import {ApiUserService} from './service/api-user.service';
import {PopupsComponent} from './modal-edit/popups/popups.component';
import {UpdatePasswordComponent} from './modal-edit/update-password/update-password.component';
import {MessagingService} from './service/messaging.service';
import {ErrorHandlerComponent} from './modal-edit/error-handler/error-handler.component';
import {RolePermissionsDirective} from './shared/role-permissions.directive';
import {OrganizationsComponent} from './main/organizations/organizations.component';
import {OrganizationUsersComponent} from './main/organizations/organization-users/organization-users.component';
import {OrderModule} from 'ngx-order-pipe';
import {SearchContractsPipe} from './shared/pipes/search-contracts.pipe';
import {UpdateMyAccountComponent} from './modal-edit/update-my-account/update-my-account.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import { TextModalComponent } from './text-modal/text-modal.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ForgotPasswordComponent,
    VerificationComponent,
    ResetPasswordComponent,
    ActivationComponent,
    MainComponent,
    HeaderComponent,
    DropdownDirective,
    UserEditModalComponent,
    CreateUserComponent,
    ActiveStatusPipe,
    CreateApiKeyComponent,
    SearchFilterPipe,
    StoreFilterCountPipe,
    OrganisationFormComponent,
    PopupsComponent,
    UpdatePasswordComponent,
    ErrorHandlerComponent,
    RolePermissionsDirective,
    OrganizationsComponent,
    OrganizationUsersComponent,
    SearchContractsPipe,
    UpdateMyAccountComponent,
    SupportComponent,
    VerifyEmailComponent,
    TextModalComponent,
    AnalyticsComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    PasswordStrengthBarModule,
    HttpModule,
    OrderModule,
    ReactiveFormsModule,
    AngularFontAwesomeModule,
    NgbModule.forRoot(),
    RouterModule.forRoot([
      {
        path: '',
        component: LoginComponent
      },
      {
        path: 'login',
        component: LoginComponent
      },
      {
        path: 'activation',
        //canActivate: [AuthGuard],
        component: ActivationComponent
      },
      {
        path: 'verification',
        canActivate: [AuthGuard],
        component: VerificationComponent
      },
      {
        path: 'forgotpassword',
        component: ForgotPasswordComponent
      },
      {
        path: 'resetpassword',
        component: ResetPasswordComponent
      },
      {
        path: 'main',
        canActivate: [AuthCodeGuard],
        component: MainComponent
      },
      {
        path: 'main/:org',
        canActivate: [AuthCodeGuard],
        component: OrganizationsComponent
      },
      {
        path: 'main/:org/:id',
        canActivate: [AuthCodeGuard],
        component: OrganizationUsersComponent
      },
      {
        path: 'orguser/activate/:key',
        component: VerifyEmailComponent
      },
      {
          path: 'analytics',
          canActivate: [AuthCodeGuard],
          component: AnalyticsComponent
      },
      {
        path: '**',
        redirectTo: '/login'
      }
    ])
  ],

  entryComponents: [
    CreateUserComponent,
    CreateApiKeyComponent,
    OrganisationFormComponent,
    UpdatePasswordComponent,
    PopupsComponent,
    UpdateMyAccountComponent,
    TextModalComponent
  ],

  providers: [ApiUserService, UserService, OrganizationService, AuthGuard, AuthCodeGuard, MessagingService],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts